import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthFrame from "./v2/AuthFrame";
import { TitleBlock, Note, Actions, PrimaryBtn, InlineLink } from "./v2/pieces";
import { resendVerificationEmail } from "./v2/authV2Services";

// 03a · Check your email. Only accounts from the old link flow wait for a
// confirmation link (the log in screen sends an unconfirmed one here); V2
// sign-ups confirm a 6-digit code before the account exists and never land
// here. The email comes in the route state; without it (a reload) the page
// points back to log in, which sends it here again.
const CheckEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location?.state?.email || "";
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);
  const toLogin = () => navigate("/login");

  const resend = async () => {
    setSending(true); setResult(null);
    try {
      const { ok, status, data } = await resendVerificationEmail({ email });
      if (ok) setResult({ tone: "success", text: data?.message || "Verification email re-sent." });
      else if (status === 429) setResult({ tone: "critical", text: data?.message || "Please wait a minute before requesting another link." });
      else setResult({ tone: "critical", text: data?.message || "We could not resend the email. Try again." });
    } catch {
      setResult({ tone: "critical", text: "We could not reach CACHE. Try again." });
    } finally { setSending(false); }
  };

  if (!email) {
    return (
      <AuthFrame title="Create your account" onBack={toLogin}>
        <TitleBlock eyebrow="Verification" title="Check your email" sub="Open the confirmation link we emailed you. To get a new link, log in with that email." />
        <Actions>
          <PrimaryBtn onClick={toLogin}>Go to log in</PrimaryBtn>
        </Actions>
      </AuthFrame>
    );
  }

  return (
    <AuthFrame title="Create your account" onBack={toLogin}>
      <TitleBlock
        eyebrow="Verification"
        title="Check your email"
        sub={<>We sent a confirmation link to <span className="font-semibold max-sm:break-words">{email}</span></>}
      />
      <Note>Click the link inside to activate your account. The link expires in 7 days.</Note>
      {result && <Note tone={result.tone}>{result.text}</Note>}
      <Actions>
        <PrimaryBtn onClick={resend} loading={sending}>Resend email</PrimaryBtn>
        <InlineLink text="Already verified?" label="Sign in" onClick={toLogin} />
      </Actions>
    </AuthFrame>
  );
};

export default CheckEmail;
